import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Star, Quote } from 'lucide-react';

interface TestimonialProps {
  content: string;
  name: string;
  title: string;
  rating: number;
}

const testimonials: TestimonialProps[] = [
  {
    content: "والله ما شاء الله خدمة النداء ساعدتني كثير في تحسين درجاتي في الفيزياء والرياضيات. شرحهم واضح ويصبرون علينا لين نفهم كل شيء زين.",
    name: "أحمد س.",
    title: "طالب مرحلة ثانوية",
    rating: 5
  },
  {
    content: "مرة استفدت من دروسهم. كنت متعثر في الكيمياء بس الحين صرت من المتفوقين. المدرس يشرح بطريقة سهلة وواضحة.",
    name: "فيصل م.",
    title: "طالب مرحلة ثانوية",
    rating: 5
  },
  {
    content: "ولدي تحسن مستواه في الرياضيات بشكل ملحوظ من بعد ما بدأ مع النداء. الأسلوب ممتاز والنتائج تتكلم.",
    name: "محمد ع.",
    title: "ولي أمر طالب ابتدائي",
    rating: 5
  },
  {
    content: "ساعدوني في التحضير للاختبارات النهائية وجبت درجات ما كنت أتوقعها. طريقتهم في المراجعة مرة حلوة.",
    name: "سارة ن.",
    title: "طالبة مرحلة متوسطة",
    rating: 5
  },
  {
    content: "الحمدلله رفعت معدلي في الأحياء من متوسط لممتاز. يشرحون المواضيع الصعبة بطريقة سهلة وحلوة.",
    name: "نورة ص.",
    title: "طالبة مرحلة ثانوية",
    rating: 5
  },
  {
    content: "بناتي الثلاث يدرسون مع النداء من فتره. النتائج مرة حلوة والتحسن واضح في كل المواد.",
    name: "منى ر.",
    title: "ولية أمر",
    rating: 5
  },
  {
    content: "المعلمين عندهم خبرة ويهتمون بالطلاب مرة. ساعدوني أفهم الفيزياء بشكل أفضل بكثير.",
    name: "عبدالله ح.",
    title: "طالب مرحلة ثانوية",
    rating: 5
  },
  {
    content: "خدمة ممتازة والأسعار مناسبة. ولدي تحسن كثير في الإنجليزي والرياضيات من بعد ما بدأ معهم.",
    name: "خالد ص.",
    title: "ولي أمر طالب متوسط",
    rating: 5
  },
  {
    content: "طريقتهم في شرح العلوم خلتها سهلة ومفهومة. قدرت أحسن درجاتي خلال فصل واحد بس.",
    name: "ريم م.",
    title: "طالبة مرحلة متوسطة",
    rating: 5
  },
  {
    content: "مرة مبسوطة من مستوى الشرح والمتابعة. صرت أفهم الدروس بسهولة وأحل الواجبات بنفسي.",
    name: "لمى ع.",
    title: "طالبة مرحلة ابتدائية",
    rating: 5
  }
];

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  // التنقل التلقائي
  useEffect(() => {
    if (!isAutoPlaying) return;
    
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => 
        prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);

    return () => clearInterval(interval);
  }, [isAutoPlaying]);

  const next = () => {
    setIsAutoPlaying(false);
    setCurrentIndex((prevIndex) => 
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prev = () => {
    setIsAutoPlaying(false);
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const goToSlide = (index: number) => {
    setIsAutoPlaying(false);
    setCurrentIndex(index);
  };

  return (
    <section className="py-20 md:py-28 bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="container mx-auto px-4">
        {/* العنوان الرئيسي */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            آراء طلابنا وأولياء الأمور
          </h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            شوف وش يقولون الطلاب وأولياء الأمور عن تجربتهم مع خدماتنا التعليمية المتميزة
          </p>
        </div>
        
        <div className="max-w-5xl mx-auto">
          <div className="relative">
            {/* الشهادة الحالية */}
            <div className="overflow-hidden rounded-2xl">
              <div 
                className="flex transition-transform duration-500 ease-in-out" 
                style={{ transform: `translateX(${currentIndex * 100}%)` }}
              >
                {testimonials.map((testimonial, index) => (
                  <div 
                    key={index} 
                    className="w-full flex-shrink-0 p-10 md:p-12 bg-white rounded-2xl shadow-2xl border border-gray-100"
                  >
                    {/* أيقونة الاقتباس */}
                    <div className="flex justify-center mb-6">
                      <div className="bg-blue-100 p-4 rounded-full">
                        <Quote className="h-8 w-8 text-blue-800" />
                      </div>
                    </div>

                    {/* النجوم */}
                    <div className="flex justify-center mb-6">
                      {[...Array(5)].map((_, i) => (
                        <Star 
                          key={i} 
                          className={`h-6 w-6 mx-1 ${
                            i < testimonial.rating 
                              ? 'fill-amber-400 text-amber-400' 
                              : 'text-gray-300'
                          }`} 
                        />
                      ))}
                    </div>

                    {/* المحتوى */}
                    <p className="text-gray-700 text-xl md:text-2xl mb-8 italic leading-relaxed text-center">
                      "{testimonial.content}"
                    </p>

                    {/* معلومات الشخص */}
                    <div className="text-center">
                      <h4 className="font-bold text-xl text-gray-900 mb-2">
                        {testimonial.name}
                      </h4>
                      <p className="text-gray-600 text-lg">
                        {testimonial.title}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            {/* أزرار التنقل */}
            <button 
              onClick={prev}
              className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 md:translate-x-8 bg-white rounded-full p-4 shadow-xl hover:shadow-2xl focus:outline-none transition-all duration-300 hover:bg-blue-50 group"
              aria-label="التقييم السابق"
            >
              <ChevronLeft className="h-6 w-6 text-blue-800 group-hover:text-blue-900" />
            </button>
            
            <button 
              onClick={next}
              className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1/2 md:-translate-x-8 bg-white rounded-full p-4 shadow-xl hover:shadow-2xl focus:outline-none transition-all duration-300 hover:bg-blue-50 group"
              aria-label="التقييم التالي"
            >
              <ChevronRight className="h-6 w-6 text-blue-800 group-hover:text-blue-900" />
            </button>
          </div>
          
          {/* مؤشرات التنقل */}
          <div className="flex justify-center mt-10 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-4 h-4 mx-1 rounded-full transition-all duration-300 ${
                  currentIndex === index 
                    ? 'bg-blue-800 scale-125' 
                    : 'bg-gray-300 hover:bg-gray-400'
                }`}
                aria-label={`الانتقال إلى التقييم ${index + 1}`}
              />
            ))}
          </div>

          {/* إحصائيات سريعة */}
          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center bg-white p-8 rounded-xl shadow-lg">
              <div className="text-4xl font-bold text-blue-800 mb-2">+1000</div>
              <div className="text-gray-600 text-lg">طالب راضٍ</div>
            </div>
            <div className="text-center bg-white p-8 rounded-xl shadow-lg">
              <div className="text-4xl font-bold text-teal-600 mb-2">95%</div>
              <div className="text-gray-600 text-lg">معدل الرضا</div>
            </div>
            <div className="text-center bg-white p-8 rounded-xl shadow-lg">
              <div className="text-4xl font-bold text-amber-500 mb-2">4.9</div>
              <div className="text-gray-600 text-lg">تقييم من 5</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;